<template>
  <div>
    <vue-header :user="user" />
    <scanner />
  </div>
</template>

<script>
import VueHeader from "@/components/header.vue";
import Scanner from "@/components/user/scanning/PalletScanner.vue";
import User from "@/models/User.js";
export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    VueHeader,
    Scanner,
  },
};
</script>
